//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import { productInfoModal } from '@/views/modals'
export default {
  name: 'SalesFindPage',
  extends: vComponent,
  components: { productInfoModal },
  data () {
    return {
      options: [
        { label: '商品名稱', key: 'PC_NAME' },
        { label: '商品編號', key: 'PLU_CODE' }
      ],
      selectedLabel: '請選擇',
      items: [], // 取得的資料
      meta: {},
      columns: [ // 欄位宣告
        { name: 'PLU_CODE', label: '商品編號', field: 'PLU_CODE' },
        { name: 'BARCODE', label: '條碼', field: 'BARCODE' },
        { name: 'PC_NAME', label: '商品名稱', field: 'PC_NAME' },
        { name: 'CO_PRICE', label: '原價', field: 'CO_PRICE' },
        { name: 'S_PRICE', label: '特價', field: 'S_PRICE' },
        { name: 'MEMO', label: '備註', field: 'MEMO' },
        { name: 'PIC_URL1', label: '圖檔路徑', field: 'PIC_URL1' }
      ],
      pagination: {
        page: 1, // 目前第幾頁
        rowsPerPage: 50, // 每頁幾筆
        rowsNumber: 20 // 總筆數
      },
      queryParams: { // 查詢條件
        key: null,
        val: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'builderHost',
      'dateFormat',
      'site',
      'theme'
    ])
  },
  async created () {
    await this.doQuery()
  },
  methods: {
    onOptionClick (key) {
      this.queryParams.key = key
      let label = null
      this.options.forEach(item => {
        if (key === item.key) label = item.label
      })
      if (label !== null) this.selectedLabel = label
    },
    async clickOpenDetail (row) {
      row.PIC_URL1_FULL = this.getImgUrl(row.PIC_URL1)
      console.log(row.PIC_URL1)
      this.showModal('infoModal', row)
    },
    async doQuery () {
      const data = { SITE: this.site }
      if (this.queryParams.key !== null) data[this.queryParams.key] = `%${this.queryParams.val}%`
      data.countPerPage = this.pagination.rowsPerPage
      data.currentPage = this.pagination.page
      const response = await this.fetch('builderApi', this.builderHost, 'crm_product', data)
      this.items = response.data !== null ? response.data : []
      this.meta = response.meta
      this.pagination.rowsNumber = this.meta.total
    },
    async onRequest (props) {
      const { page, rowsPerPage } = props.pagination
      // const filter = props.filter
      this.pagination.page = page
      this.pagination.rowsPerPage = rowsPerPage
      console.log('on request props=')
      console.log(props)
      await this.doQuery()
    },
    getImgUrl (imgName) {
      if (imgName !== '' && imgName !== null) {
        return `http://jabezpos2.s3.amazonaws.com/DBF01/BAS03060/Graph/${imgName}`
      } else {
        return 'static/images/default/default_product.png'
      }
    }
  }
}
